const config = {
  routes: {
    label: 'New FAQs',
    prefix: '/new_faq',
  },
}

export default config
